import React, { FC, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'src/common';
import { Checkbox } from 'antd';
import styles from './index.module.scss';
import { JunctionLogic } from '@tendium/prom-types';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';

interface FormState {
  supplierSearchLogic: boolean;
}

const SupplierSearchLogicQuickFilter: FC = () => {
  const { t } = useTranslation();
  const [{ vars: searchArgs }, updateSearchArgs] = useApiTenders();

  const [form] = Form.useForm<FormState>();

  useEffect(() => {
    form.setFieldsValue({
      supplierSearchLogic: searchArgs?.supplierSearchLogic === JunctionLogic.AND
    });
  }, [form, searchArgs?.supplierSearchLogic]);

  const onValuesChange = useCallback(
    (changedValues: FormState) => {
      const newSearchLogic = changedValues.supplierSearchLogic ? JunctionLogic.AND : JunctionLogic.OR;
      updateSearchArgs({ supplierSearchLogic: newSearchLogic });
    },
    [updateSearchArgs]
  );

  return (
    <>
      <Form className={styles.form} onValuesChange={onValuesChange} form={form}>
        <Form.Item name={'supplierSearchLogic'} valuePropName={'checked'}>
          <Checkbox>{t('ExpiringContracts.supplierJunctionLogic')}</Checkbox>
        </Form.Item>
      </Form>
    </>
  );
};

export default SupplierSearchLogicQuickFilter;
